import { orderApi, customerApi } from '../../api';

const state = {
  remarksSyncStatus: {}, // 存储每个订单的同步状态 { orderId: 'pending' | 'success' | 'error' }
  remarksSyncErrors: {}  // 存储同步错误信息 { orderId: errorMessage }
};

const mutations = {
  SET_REMARKS_SYNC_STATUS(state, { orderId, status }) {
    state.remarksSyncStatus = {
      ...state.remarksSyncStatus,
      [orderId]: status
    };
  },
  SET_REMARKS_SYNC_ERROR(state, { orderId, error }) {
    state.remarksSyncErrors = {
      ...state.remarksSyncErrors,
      [orderId]: error
    };
  },
  CLEAR_REMARKS_SYNC_STATUS(state, orderId) {
    if (orderId) {
      const newStatus = { ...state.remarksSyncStatus };
      const newErrors = { ...state.remarksSyncErrors };
      delete newStatus[orderId];
      delete newErrors[orderId];
      state.remarksSyncStatus = newStatus;
      state.remarksSyncErrors = newErrors;
    } else {
      state.remarksSyncStatus = {};
      state.remarksSyncErrors = {};
    }
  }
};

const actions = {
  // 同步订单备注到客户备注
  async syncRemarks({ commit }, { orderId, remarks, syncToCustomer = true }) {
    commit('SET_REMARKS_SYNC_STATUS', { orderId, status: 'pending' });
    commit('SET_REMARKS_SYNC_ERROR', { orderId, error: null });
    
    try {
      const response = await orderApi.syncRemarks(orderId, {
        remarks,
        sync_to_customer: syncToCustomer
      });
      
      if (response.code === 200) {
        commit('SET_REMARKS_SYNC_STATUS', { orderId, status: 'success' });
        return { success: true, data: response.data };
      } else {
        throw new Error(response.message || '同步失败');
      }
    } catch (error) {
      const errorMsg = error.response?.data?.message || error.message || '同步备注失败';
      commit('SET_REMARKS_SYNC_STATUS', { orderId, status: 'error' });
      commit('SET_REMARKS_SYNC_ERROR', { orderId, error: errorMsg });
      return { success: false, error: errorMsg };
    }
  },
  
  // 清除同步状态
  clearSyncStatus({ commit }, orderId) {
    commit('CLEAR_REMARKS_SYNC_STATUS', orderId);
  }
};

const getters = {
  getRemarksSyncStatus: (state) => (orderId) => {
    return state.remarksSyncStatus[orderId] || null;
  },
  getRemarksSyncError: (state) => (orderId) => {
    return state.remarksSyncErrors[orderId] || null;
  },
  isSyncPending: (state) => (orderId) => {
    return state.remarksSyncStatus[orderId] === 'pending';
  },
  isSyncSuccess: (state) => (orderId) => {
    return state.remarksSyncStatus[orderId] === 'success';
  },
  isSyncError: (state) => (orderId) => {
    return state.remarksSyncStatus[orderId] === 'error';
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};